// eslint-disable
import React, { useEffect, useMemo } from 'react';
import Select from 'react-select';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { GET_REGIONS } from './constant';
import { getRegions } from './actions';


const makeListSelector = () => createSelector(
  ({ api }, name) => _.get(api, `${GET_REGIONS}/${name}.list`) || [],
  (list) => list.map(item => ({
    label: _.get(item, 'attributes.name'),
    value: _.get(item, 'id'),
    fullInfo: item,
  }))
)

const Region = ({ name, onChange, value, styles, readOnly, isDisabled }) => {
  
  const dispatch = useDispatch()
  const selectList = useMemo(makeListSelector, [])
  const isLoading = useSelector(({ api }) => api.loading.indexOf(`${GET_REGIONS}/${name}`) > -1)
  const list = useSelector(state => selectList(state, name))
  // const options = formatOptions(list)

  const findValue = list.find(item => _.get(item, 'fullInfo.attributes.code') === value) || ''

  useEffect(() => {
    dispatch(getRegions(name))
  }, [])

  return (
    readOnly === true ?
      (
        <span className="full-input text-uppercase">
          {_.get(findValue, 'label')}
        </span>
      )
    : 
      (
        <Select 
          placeholder="- Select -"
          isClearable
          isDisabled={isDisabled}
          isLoading={isLoading}
          styles={styles}
          value={findValue}
          onChange={onChange}
          options={list}
          components={{
            IndicatorSeparator: () => null,
          }}
        />
      )
  )
}

Region.defaultProps = {
  styles: {},
  readOnly: undefined,
  isDisabled: false,
  name: undefined
}

Region.propTypes = {
  name: PropTypes.string,
  readOnly: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.string.isRequired,
  styles: PropTypes.instanceOf(Object)
}

export default Region